var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import ActionDelete from '@mui/icons-material/Delete';
import clsx from 'clsx';
import { useDeleteWithUndoController, useRecordContext, useResourceContext, useTranslate, useGetRecordRepresentation, useResourceTranslation, } from 'ra-core';
import { humanize, singularize } from 'inflection';
import { Button } from './Button';
import { styled, useThemeProps, } from '@mui/material/styles';
export var DeleteWithUndoButton = function (inProps) {
    var props = useThemeProps({
        props: inProps,
        name: PREFIX,
    });
    var labelProp = props.label, className = props.className, _a = props.icon, icon = _a === void 0 ? defaultIcon : _a, onClick = props.onClick, _b = props.redirect, redirect = _b === void 0 ? 'list' : _b, mutationOptions = props.mutationOptions, _c = props.color, color = _c === void 0 ? 'error' : _c, successMessage = props.successMessage, rest = __rest(props, ["label", "className", "icon", "onClick", "redirect", "mutationOptions", "color", "successMessage"]);
    var record = useRecordContext(props);
    var resource = useResourceContext(props);
    if (!resource) {
        throw new Error('<DeleteWithUndoButton> components should be used inside a <Resource> component or provided with a resource prop. (The <Resource> component set the resource prop for all its children).');
    }
    var _d = useDeleteWithUndoController({
        record: record,
        resource: resource,
        redirect: redirect,
        onClick: onClick,
        mutationOptions: mutationOptions,
        successMessage: successMessage,
    }), isPending = _d.isPending, handleDelete = _d.handleDelete;
    var translate = useTranslate();
    var getRecordRepresentation = useGetRecordRepresentation(resource);
    var recordRepresentation = getRecordRepresentation(record);
    var resourceName = translate("resources.".concat(resource, ".forcedCaseName"), {
        smart_count: 1,
        _: humanize(translate("resources.".concat(resource, ".name"), {
            smart_count: 1,
            _: resource ? singularize(resource) : undefined,
        }), true),
    });
    // We don't support React elements for this
    if (React.isValidElement(recordRepresentation)) {
        recordRepresentation = "#".concat(record === null || record === void 0 ? void 0 : record.id);
    }
    var label = useResourceTranslation({
        resourceI18nKey: "resources.".concat(resource, ".action.delete"),
        baseI18nKey: 'ra.action.delete',
        options: {
            name: resourceName,
            recordRepresentation: recordRepresentation,
        },
        userText: labelProp,
    });
    return (React.createElement(StyledButton, __assign({ onClick: handleDelete, disabled: isPending, 
        // avoid double translation
        label: React.createElement(React.Fragment, null, label), "aria-label": typeof label === 'string' ? label : undefined, className: clsx('ra-delete-button', className), key: "button", color: color }, rest), icon));
};
var defaultIcon = React.createElement(ActionDelete, null);
var PREFIX = 'RaDeleteWithUndoButton';
var StyledButton = styled(Button, {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})({});
//# sourceMappingURL=DeleteWithUndoButton.js.map